export default "__VITE_ASSET__U9Foc3zK__"